// removed by extract-text-webpack-plugin
module.exports = {"BreakpointToMedium":"(max-width: 639px)","BreakpointFromLarge":"(min-width: 960px)","Mackerel":"#D2D6D9","heading":"Ga319a3","line":"Gf56fd7"};